// 9fbef606107a605d69c0edbcd8029e5d
import GLOBAL_CONSTANTS from '../constants';

export const loadLayoutData = (payload, layoutName) => {
  return {
    payload,
    layoutName,
    type: GLOBAL_CONSTANTS.LOAD_LAYOUT_DATA,
  };
};

export const loadLabelsData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.LOAD_LABELS_DATA,
  };
};
export const setLabelsData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_LABELS_DATA,
  };
};

export const loadComponentLabelsData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.LOAD_COMPONENT_LABELS_DATA,
  };
};

export const loadSEOData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.LOAD_SEO_DATA,
  };
};
export const setSEOData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_SEO_DATA,
  };
};

export const loadPageSEOData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.LOAD_PAGE_SEO_DATA,
  };
};

export const loadXappConfigData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_XAPP_CONFIG,
  };
};

export const loadXappConfigDataOtherBrand = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_XAPP_CONFIG_OTHER_BRAND,
  };
};

export const setBossBopisFlags = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_BOSS_BOPIS_FLAGS,
  };
};

export const fetchLastUpdated = (payload, callback) => {
  return {
    payload,
    callback,
    type: GLOBAL_CONSTANTS.FETCH_LAST_UPDATED,
  };
};
export const setLastUpdated = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_LAST_UPDATED,
  };
};

export const setAPIConfig = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_API_CONFIG,
  };
};

export const setLocationEnabledValue = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_LOCATION_STATUS,
  };
};

export const setDeviceIDValue = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_DEVICE_ID,
  };
};

export const siteConfigData = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.SITE_CONFIG,
    payload,
  };
};

export const bootstrapData = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.BOOTSTRAP_API,
    payload,
  };
};

export const fetchLabelsData = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.FETCH_LABELS,
    payload,
  };
};

export const setBootstrapError = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.BOOTSTRAP_API_ERROR,
    payload,
  };
};

export const loadModulesData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.LOAD_MODULES_DATA,
  };
};

export const getCountryListData = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.COUNTRY_LIST_GET_DATA,
  };
};

export const storeCountriesMap = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.COUNTRY_LIST_STORE_COUNTRIES_MAP,
  };
};

export const storeCurrenciesMap = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.COUNTRY_LIST_STORE_CURRENCIES_MAP,
  };
};

export const setServerTime = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_SERVER_TIME,
  };
};

export const getServerTime = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.GET_SERVER_TIME,
  };
};

export const setCountry = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_COUNTRY,
  };
};

export const setCountryName = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_COUNTRY_NAME,
  };
};

export const setCurrency = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_CURRENCY,
  };
};

export const setLanguage = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_LANGUAGE,
  };
};

export const setDeviceInfo = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.SET_DEVICE_INFO,
});

export const setOptimizelyFeaturesList = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.SET_OPTIMIZELY_FEATURES_LIST,
});

export const fetchPageLayout = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.FETCH_PAGE_LAYOUT,
});

export const getSetTcpSegment = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.GET_SET_TCP_SEGMENT,
});

export const SetTcpSegmentMethodCall = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.SET_TCP_SEGMENT_METHOD_CALL,
});

export const setPreviewDate = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_PREVIEW_DATE,
  };
};

export const setBrandSwitched = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_IS_BRAND_SWITCHED,
  };
};

export const setBrandSwitchedApolloStatefulClient = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_IS_BRAND_SWITCHED_APOLLO_STATEFUL_GRAPHQL,
  };
};

export const setToken = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_SFCC_AUTH_TOKEN,
  };
};

export const getToken = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.FETCH_SFCC_AUTH_TOKEN,
  };
};

export const setSubNavigationData = (payload, name) => ({
  payload,
  name,
  type: GLOBAL_CONSTANTS.SET_SUB_NAVIGATION_DATA,
});

export const getSubNavigationData = (payload) => ({
  payload,
  type: GLOBAL_CONSTANTS.GET_SUB_NAVIGATION_DATA,
});

export const fetchHeaderData = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.FETCH_GLOBAL_HEADER,
    payload,
  };
};

export const fetchFooterData = (payload) => {
  return {
    type: GLOBAL_CONSTANTS.FETCH_FOOTER,
    payload,
  };
};

export const setCartsSessionStatus = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_CARTS_SESSION_STATUS,
  };
};

export const setCheckoutMetricsStatus = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_CHECKOUT_METRICS_STATUS,
  };
};

export const setNonInventoryStagSessionFlag = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.SET_NON_INVENTORY_STAGE_SESSION_FLAG,
  };
};

export const toggleSiteMaintenanceBanner = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.TOGGLE_SITE_MAINTENANCE_BANNER,
  };
};

export const setPromoSplashLoading = (payload) => {
  return {
    payload,
    type: GLOBAL_CONSTANTS.PROMO_SPLASH_LOADING,
  };
};

export const loadPromoCombinationData = (payload, cid) => {
  return {
    payload,
    cid,
    type: GLOBAL_CONSTANTS.LOAD_PROMO_COMBINATION_DATA,
  };
};

export const setPageVisibilityTitle = (payload) => ({
  type: GLOBAL_CONSTANTS.PAGE_VISIBILITY_TITLE,
  payload,
});

export default {
  loadLayoutData,
  loadLabelsData,
  setLabelsData,
  loadComponentLabelsData,
  bootstrapData,
  setBootstrapError,
  loadModulesData,
  getCountryListData,
  storeCountriesMap,
  storeCurrenciesMap,
  setCountry,
  setCurrency,
  setLanguage,
  setBossBopisFlags,
  getSetTcpSegment,
  SetTcpSegmentMethodCall,
  setPreviewDate,
  setSubNavigationData,
  setNonInventoryStagSessionFlag,
  loadPromoCombinationData,
  setPageVisibilityTitle,
};
